import { Box, Chip, Typography } from '@mui/material'
import CardWithSpace from '../../../components/Cards/CardWithSpace/index.jsx'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import TitleWithIcon from '../../../components/Cards/helpers/TitleWithIcon.jsx'
import { ReactComponent as SingleCompanyIcon } from '../../../images/SingleCompany.svg'
import TitleWithInfo from '../../../components/Cards/helpers/TitleWithInfo.jsx'

const CompanyDetails = ({ companyDetails }) => {
  const { t } = UseTranslation()

  return (
    <Box sx={styles.sectionGroup}>
      <Box sx={styles.sectionHeader}>
        <TitleWithIcon title={t?.['GENERAL DETAILS']} icon={<SingleCompanyIcon />} iconSize="sm" customStyle={styles.sectionOverline} />
        </Box>
      <CardWithSpace customStyles={styles.detailsCardShell}>
        <Box sx={styles.detailsHeader}>
          <Typography component="h2" sx={styles.detailsTitle}>
            {t?.['Company details']}
          </Typography>
          <Typography sx={styles.detailsSubtitle}>
            {t?.['Core identity and integration settings']}
          </Typography>
        </Box>

        <Box sx={styles.detailsBody}>
          <TitleWithInfo title={t?.['Company name']} info={companyDetails.name} customStyle={styles.detailRow} />
          <TitleWithInfo title={t?.['Tenant ID']} info={companyDetails.tenant_list?.[0]?.name} customStyle={styles.detailRow} />
          <TitleWithInfo
            title={t?.Integration}
            info={companyDetails.tenant_list?.[0]?.integration?.type ? (
              <Chip
                label={companyDetails.tenant_list?.[0]?.integration.type}
                size="small"
                sx={styles.integrationBadge}
              />
            ) : (
              null
            )}
            customStyle={styles.detailRow}
          />
          <TitleWithInfo
            title={t?.['Core tenant']}
            info={companyDetails.tenant_list?.[0]?.fabs_tenant?.name}
            customStyle={styles.detailRow}
          />
        </Box>
      </CardWithSpace>
    </Box>
  )
}

const styles = {
  sectionGroup: {
    width: '100%',
    mb: { xs: 2.5, sm: 3 },
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 2,
    mb: 1.25,
  },
  sectionOverline: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#92929d',
    lineHeight: 1.3,
    '& svg': {
      stroke: '#92929d',
    },
  },
  detailsCardShell: {
    border: '1px solid #e8eaed',
    borderRadius: '12px',
    boxShadow: 'none',
    marginBottom: 0,
    overflow: 'hidden',
    padding: 0,
  },
  detailsHeader: {
    px: { xs: 2.5, sm: 3 },
    pt: { xs: 2.5, sm: 3 },
    pb: { xs: 2, sm: 2.5 },
    borderBottom: '1px solid #ebecef',
  },
  detailsTitle: {
    fontWeight: 700,
    fontSize: { xs: '1rem', sm: '1.0625rem' },
    color: '#1b2559',
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
  },
  detailsSubtitle: {
    mt: 0.75,
    fontSize: { xs: '0.75rem', sm: '0.8125rem' },
    fontWeight: 400,
    color: '#92929d',
    lineHeight: 1.45,
    maxWidth: '520px',
  },
  detailsBody: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    px: { xs: 2.5, sm: 3 },
    py: { xs: 2, sm: 2.25 },
    borderBottom: '1px solid #ebecef',
    marginRight: '0px !important',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(29, 158, 117, 0.05)',
    },
    ' & h5': {
      flexShrink: 0,
      width: { xs: '100px', sm: '300px' },
      minWidth: { xs: '100px', sm: '300px' },
      maxWidth: { xs: '100px', sm: '300px' },
      fontSize: { xs: '0.8125rem', sm: '0.875rem' },
      fontWeight: 400,
      color: '#92929d',
      lineHeight: 1.4,
    },
    ' & h6': {
      textAlign: { xs: 'right', sm: 'left' },
      width: { xs: '100px', sm: 'unset' },
      fontSize: '14px',
      flex: 1,
      textTransform: 'none',
      wordBreak: 'break-word',
    },
  },
  detailRowLast: {
    borderBottom: 'none',
  },
  integrationBadge: {
    height: 28,
    fontWeight: 600,
    fontSize: '0.75rem',
    color: '#29CC8B',
    backgroundColor: 'rgba(41, 204, 139, 0.12)',
    border: '1px solid #29CC8B',
    borderRadius: '999px',
    alignSelf: { xs: 'flex-end', sm: 'center' },
    '& .MuiChip-label': {
      px: 1.25,
    },
  },
}

export default CompanyDetails
